import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import useTimeoutEffect from "./useTimeoutEffect";
import { useMeetingStore } from "../../stores/useMeetingStore";
import { useUserStore } from "../../stores/useUserStore";
import useGetMeeting from "../api/useGetMeeting";
import useMeetingChangeSocket from "../api/useMeetingChangeSocket";
import useShowError from "./useShowError";
import { toString } from "../../utilities/stringify";

const useMeetingFromParams = () => {
    const navigate = useNavigate();
    const meetingId = (useParams() as { id: string }).id;

    const { setMeeting, meeting } = useMeetingStore();
    const user = useUserStore((state) => state.user);

    useMeetingChangeSocket({ meetingId });
    const { getMeeting, loading, error, clearError } = useGetMeeting();

    useShowError(error, clearError);

    useTimeoutEffect(
        () => {
            if (meetingId.length === 0) {
                console.warn("Meeting ID is empty, navigating to home");
                navigate("/");
            }
            else if (meeting?.id !== meetingId) {
                (async () => {
                    console.log(`Loading meeting: ${meetingId}`);
                    let loadedMeeting = await getMeeting(meetingId);
                    if (!loadedMeeting) {
                        console.warn(`Meeting ${meetingId} not found, navigating to home`);
                        return navigate("/");
                    }
                    console.log(`Meeting ${meetingId} loaded successfully`);
                    setMeeting(loadedMeeting);
                })();
            }
        },
        [user.id],
        1000  
    );

    return loading;
};

export default useMeetingFromParams;
